<template>
  <v-navigation-drawer :height="drawerHeight"
                       :style="{ 'box-shadow': drawerState ? '0 -5px 7px 1px rgba(0,0,0,0.5)' : '' }"
                       :value="drawerState"
                       absolute
                       app
                       class="transition-ease-in-out"
                       color="primary"
                       disable-resize-watcher
                       disable-route-watcher
                       floating
                       :right="!$vuetify.rtl"
                       :left="$vuetify.rtl"
                       stateless
                       style="padding-top: 90px !important;"
                       width="400"
  >
    <transition name="fade-transition">
      <drawer-settings :drawer-state="drawerState" v-if="drawerState"></drawer-settings>
    </transition>
  </v-navigation-drawer>
</template>

<script>
    import DrawerSettings from "../../settings/DrawerSettings";

    export default {
        components: {
            DrawerSettings
        },
        name: "AppSettingsDrawer",
        computed: {
            drawerHeight() {
                return window.innerHeight - 90;
            }
        },
        data: () => ({
            drawerState: false
        }),
        watch: {
            '$store.state.settings.isOpen'(val) {
                this.drawerState = val;
            }
        }
    }
</script>

<style scoped>

</style>